import React from "react"
import Answer from "./Answer"

function Question({
  answers, descriptor, formIndex, label, onChangeHandler, selectedAnswer
}) {
  const forceListLayout = ["satisfaction_with_life", "state_satisfaction"].includes(formIndex)
  return (
    <div>
      <p>{label}</p>
      {descriptor && (
        <div className="mb-3 small">
          <i>{descriptor}</i>
        </div>
      )}
      <div
        className={forceListLayout ? "survey-answer-list" : "btn-group btn-group-toggle"}
        data-toggle="buttons">
        {answers && answers.map(answer => (
          <Answer
            answer={answer}
            onChangeHandler={onChangeHandler}
            key={answer.id}
            selectedAnswer={selectedAnswer}
            formIndex={formIndex} />
        ))}
      </div>
    </div>
  )
}

export default Question